const branches = {
  branches: {
    pageHeader: 'Filiali',
    addBranchOffice: '+ Aggiungi filiale',
    name: 'Nome',
    city: 'Città',
    state: 'Stato/Provincia',
    country: 'Nazione',
    branches: 'Filiali',
    noBranchAvailable: '** Nessuna filiale disponibile **'
  }
};

export default branches;
